import { render } from "./ai-grid-edit-core.vue?vue&type=template&id=0dbb350d&scoped=true"
import script from "./ai-grid-edit-core.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-grid-edit-core.vue?vue&type=script&setup=true&lang=js"

import "./ai-grid-edit-core.vue?vue&type=style&index=0&id=0dbb350d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbb350d"],['__file',"src/components/ai-grid-edit/ai-grid-edit-core.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dbb350d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dbb350d', __exports__)) {
    api.reload('0dbb350d', __exports__)
  }
  
  module.hot.accept("./ai-grid-edit-core.vue?vue&type=template&id=0dbb350d&scoped=true", () => {
    api.rerender('0dbb350d', render)
  })

}


export default __exports__